export default "__VITE_ASSET__qI_mM7wB__"